// Shared vitals-readings builder — driven entirely by the schema, used by both the
// patient VitalsTab (record CRUD) and the AppointmentDrawer (consult report view).

import { VitalSignField, VitalSignRecord } from "../../types/healthcare/VitalSignTypes";

export interface VitalsReading {
	key: string;
	label: string;
	display: string;
	unit: string | null;
	outOfRange: boolean;
}

/** Build the display readings for a record, driven entirely by the schema. */
export const buildVitalsReadings = (record: VitalSignRecord, schema: VitalSignField[]): VitalsReading[] =>
	schema
		.filter((field) => record.values[field.key] !== undefined && record.values[field.key] !== null)
		.map((field) => {
			const raw = record.values[field.key];
			const num = typeof raw === "number" ? raw : Number(raw);
			const isNumeric = field.type !== "coded" && !Number.isNaN(num);
			const outOfRange =
				isNumeric &&
				((field.min !== null && num < field.min) || (field.max !== null && num > field.max));
			// Coded values map their stored code to a human label when the schema knows it.
			const display =
				field.type === "coded" ? field.options?.[String(raw)] ?? String(raw) : String(raw);
			return { key: field.key, label: field.label, display, unit: field.unit, outOfRange };
		});
